import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Scrollbar } from "swiper";
import TopTitleBlock from "../../Components/TopTitleBlock/TopTitleBlock";
import MainEducationProgressLineTop from "./EducationComponents/MainEducationProgressLineTop";
import {useSelector} from "react-redux";

const Beginner = () => {
  const apiData = useSelector((state)=>state.appData.appData)
  return (
    <div className="page__content">
      <TopTitleBlock titleBack={apiData.button_back} title={"МОДУЛЬ 1"} />
      <MainEducationProgressLineTop text={"Вводный урок. О нашем бренде"} />
      <div className="page__video video">
        <div className="video__video">
          <iframe
            width="1280"
            height="720"
            src="https://www.youtube.com/embed/fKopy74weus?list=RDCLAK5uy_n1yUj1SIY2iIAIiVtdlwy6z7RLFqKXmB0"
            title="Imagine Dragons - Thunder"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="video__row">
          <div className="video__column">
            <div className="video__text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
              velit facilisi viverra mattis ultricies bibendum rhoncus.
              Porttitor consequat cursus mauris nisl. Sed nibh diam velit leo,
              sit.
            </div>
            <div className="video__text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
              velit facilisi viverra mattis ultricies bibendum rhoncus.
              Porttitor consequat cursus mauris nisl. Sed nibh diam velit leo,
              sit.
            </div>
          </div>
          <div className="video__column">
            <div className="video__text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
              velit facilisi viverra mattis ultricies bibendum rhoncus.
              Porttitor consequat cursus mauris nisl. Sed nibh diam velit leo,
              sit.
            </div>
            <div className="video__text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
              velit facilisi viverra mattis ultricies bibendum rhoncus.
              Porttitor consequat cursus mauris nisl. Sed nibh diam velit leo,
              sit.
            </div>
          </div>
        </div>
      </div>
      <div className="page__plan plan">
        <div className="plan__title">ПЛАН РАБОТЫ</div>
        <div className="plan__top">
          <div className="plan__date">001</div>
          <div className="plan__divider">---</div>
          <div className="plan__date">006</div>
        </div>
        <div className="plan__text">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, velit
          facilisi viverra mattis ultricies bibendum rhoncus. Porttitor
          consequat cursus mauris nisl. Sed nibh diam velit leo, sit. Dolor
          placerat augue tincidunt feugiat nisl.
        </div>
      </div>
      <div className="page__marketing-slider slider-marketing">
        <div className="slider-marketing__wrapper">
          <Swiper
            direction={"vertical"}
            slidesPerView={3}
            spaceBetween={0}
            scrollbar={{
              draggable: true,
              dragSize: 24,
              el: ".slider-marketing__drag-scroll",
            }}
            mousewheel={true}
            modules={[FreeMode, Scrollbar, Mousewheel]}
          >
            <SwiperSlide className="slider-marketing__slide">
              <div className="slider-marketing__item item-slider-marketing">
                <div className="item-slider-marketing__number">001</div>
                <div className="item-slider-marketing__text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
                  velit facilisi viverra mattis ultricies bibendum rhoncus.
                  Porttitor consequat cursus mauris nisl. Sed nibh diam velit
                  leo, sit. Dolor placerat augue tincidunt feugiat nisl.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="slider-marketing__slide">
              <div className="slider-marketing__item item-slider-marketing">
                <div className="item-slider-marketing__number">002</div>
                <div className="item-slider-marketing__text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
                  velit facilisi viverra mattis ultricies bibendum rhoncus.
                  Porttitor consequat cursus mauris nisl. Sed nibh diam velit
                  leo, sit. Dolor placerat augue tincidunt feugiat nisl.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="slider-marketing__slide">
              <div className="slider-marketing__item item-slider-marketing">
                <div className="item-slider-marketing__number">003</div>
                <div className="item-slider-marketing__text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
                  velit facilisi viverra mattis ultricies bibendum rhoncus.
                  Porttitor consequat cursus mauris nisl. Sed nibh diam velit
                  leo, sit. Dolor placerat augue tincidunt feugiat nisl.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="slider-marketing__slide">
              <div className="slider-marketing__item item-slider-marketing">
                <div className="item-slider-marketing__number">004</div>
                <div className="item-slider-marketing__text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
                  velit facilisi viverra mattis ultricies bibendum rhoncus.
                  Porttitor consequat cursus mauris nisl. Sed nibh diam velit
                  leo, sit. Dolor placerat augue tincidunt feugiat nisl.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className="slider-marketing__slide">
              <div className="slider-marketing__item item-slider-marketing">
                <div className="item-slider-marketing__number">005</div>
                <div className="item-slider-marketing__text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet,
                  velit facilisi viverra mattis ultricies bibendum rhoncus.
                  Porttitor consequat cursus mauris nisl. Sed nibh diam velit
                  leo, sit. Dolor placerat augue tincidunt feugiat nisl.
                </div>
              </div>
            </SwiperSlide>
            <div className="slider-marketing__scroll"> </div>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Beginner;
